<div id="appHeader">
  <nav
    class="navbar navbar-expand-lg navbar-dark navbar-absolute px-lg-3 px-md-3 px-sm-3"
  >
    <a class="navbar-brand " routerLink="/">
      <img
        src="./assets/img/logo_xs_yellow_tila.png"
        class="d-inline-block align-middle img-fluid ms-4 me-2 logo-brand"
        alt="brand_logo"
      />
    </a>
  </nav>
</div>
<div class="container-fluid">
  <div class="session-activity-container">
    <div class="row justify-content-center align-items-center">
      <div class="col-md-4 col-lg-4 col-sm-4 col-xs-12 align-self-center">
        <div class="login-blk">
          <mat-card class="p-4 text-center">
            <h2 h4>Logout Successful!</h2>
            <button mat-stroked-button routerLink="/" color="primary">
              <mat-icon>home</mat-icon> Back to home
            </button>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
